module.exports = __webpack_public_path__ + "img/img-google-download@2x.e054ff92.jpg";